<template>

    <div>
        <nav v-if="!slim" class="navbar navbar-inverse navbar-sm">
            <div class="container-fluid">
                <div class="navbar-header">
                    <a class="navbar-brand" href="#"><icon name="list-alt"></icon> Console</a>
                </div>

                <ul class="nav navbar-nav navbar-right">
                    <li @click="clear()"><a href="#"><icon name="trash"></icon></a></li>
                </ul>
            </div>
        </nav>

        <!-- Logs -->
        <div class="log head">
                <div class="level"></div>
                <div class="key">Module</div>
                <div class="time">Time</div>
                <div class="message">Message</div>
        </div>

        <div class="logs" :class="{ slim: slim, normal: !slim}" ref="logs">
            <span v-for="data in logs">
                <div class="log" :class="data.level.cssClass">
                    <div class="level"><icon v-if="data.level.icon" :name="data.level.icon"></icon></div>
                    <div class="key">{{ data.key }}</div>
                    <div class="time">{{ data.time | consoleTime }}</div>
                    <div class="message" v-if="!data.object">{{ data.message }}</div>
                    <div class="message" v-else><objectView v-model="data.message" /></div>
                </div>
            </span>
        </div>
    </div>
    
</template>

<script>
    import proxy from 'components/console/consoleProxy.js';

    import moment from 'moment';
    import Vue from 'vue'
    Vue.filter('consoleTime', function(value) {
        if (value) {
            return value.format('HH:mm:ss')
        }
    })

    import objectView from 'vue-object-view';

    export default {
        name: "console",
        props: ["keys", "slim"],
        data() {
            return {
                logs: []
            }
        },
        methods: {
            log(log) {
                this.logs.push(log);
                // Autoscroll if scrolled down - adopted from http://stackoverflow.com/questions/18614301/keep-overflow-div-scrolled-to-bottom-unless-user-scrolls-up
                var $el = this.$refs.logs;
                var scrolledDown = $el.scrollHeight - $el.clientHeight <= $el.scrollTop + 1;
                if (scrolledDown) {
                    window.setTimeout(function() {
                        $el.scrollTop = $el.scrollHeight;
                    }, 5);
                }
            },
            clear() {
                this.logs = [];
            }
        },
        components: {
            objectView
        },
        mounted() {
            proxy.register(this);
        }
    }
</script>

<style scoped>
    div.logs {
        background-color: #272822;
        overflow: auto;
    }
    .navbar-sm {
        margin-bottom: 0px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    div.head {
        background-color: #222;
        border-bottom: 1px solid #090909;
        color: #F8F8F2;
    }

    div.normal {
        height: 200px;
    }

    div.log {
        padding: 0px 4px;
    }

    div.log div {
        display: inline-block;
    }

    .level {
        width: 24px;
    }

    .key {
        width: 64px;
    }

    .time {
        width: 96px;
    }

    .message {

    }
</style>
<style lang="less">

    @import '~src/less/index.less';

    .error-msg {
      color: @error-color;
      background-color: @error-bg;
    }
    .warning-msg {
      color: @warning-color;
      background-color: @warning-bg
    }
    .debug-msg {
      color: gray;
    }
    .info-msg {
      color: #F8F8F2;
    }
</style>


// WEBPACK FOOTER //
// Console.vue?5fd452de